import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AlertService } from '../components/alert/alert.service';
import { AuthService } from '../services/auth.service';
import { PermisosService } from '../services/permisos.service';

/** Sesión caducada o token inválido (401): se cierra la sesión y se vuelve al login con un aviso claro. */
export const sessionInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const permisos = inject(PermisosService);
  const alertas = inject(AlertService);
  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401 && !/\/login(\/|$)/.test(req.url)) {
        permisos.limpiar();
        if (auth.isLoggedIn || auth.getToken()) {
          alertas.warning('Tu sesión ha caducado. Inicia sesión de nuevo.', 6000);
          auth.logout();
        }
      }
      return throwError(() => error);
    })
  );
};
